import React, { useState } from "react";
import Events from "./Events";
import Facility from "./Facility";
import Patients from "./Patients";
import Physicians from "./Users";
import Conditions from "./Conditions";
import CareConditions from "./CareOperators";
import ReadmissionAlertsOverview from "./ReadmisionAlerts";
import { useLocation } from "react-router-dom";
import AddUser from "./Users/AddUser";
import UpdateFacility from "./Facility/UpdateFacility";

interface Props {
  showReadmissionAlerts: Boolean;
}


export default function DataOverview({ showReadmissionAlerts }: Props) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const initialScreen = queryParams.get("screen") || "Facility";
  const [screen, setScreen] = useState(initialScreen);
  const [showAddUser, setShowAddUser] = useState(false);

  const renderScreen = () => {
    switch (screen) {
      case "Facility":
        return <Facility />;
      case "Users":
        return <Physicians/>;
      case "UpdateFacility":
        return <UpdateFacility />;
      case "Patients":
        return <Patients />;
      case "Events":
        return <Events />;
      case "Conditions":
        return <Conditions />;
      case "ReadmissionAlerts":
        return <ReadmissionAlertsOverview />;
      default:
        return <Facility />;
    }
  };
  return (
    <div className="container">
      <div className="flex-between ">
        <h4 className="content-title">Data overview</h4>
      </div>

      <div className="content-menu">
        <ul>
          <li
            className={`${screen === "Facility" ? "content-menu-active" : null
              }`}
            onClick={() => setScreen("Facility")}
          >
            Facility
          </li>
          <li
            className={`${screen === "Conditions" ? "content-menu-active" : null}`}
            onClick={() => setScreen("Conditions")}
          >
            Conditions
          </li>
          <li
            className={`${screen === "Users" ? "content-menu-active" : null}`}
            onClick={() => setScreen("Users")}
          >
            Users
          </li>
          <li
            className={`${screen === "Patients" ? "content-menu-active" : null
              }`}
            onClick={() => setScreen("Patients")}
          >
            Patients
          </li>
          <li
            className={`${screen === "Events" ? "content-menu-active" : null}`}
            onClick={() => setScreen("Events")}
          >
            Events
          </li>
          {(showReadmissionAlerts) ? (<li
            className={`${screen === "ReadmissionAlerts" ? "content-menu-active" : null}`}
            onClick={() => setScreen("ReadmissionAlerts")}
          >
            Alerts
          </li>) : null}
        </ul>
      </div>
      {renderScreen()}
    </div>
  );
}
